// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.custodian[data-v-9a9f4e6c] {\n    margin-left: 1em !important;\n}\n", ""]);
// Exports
module.exports = exports;
